(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/match-ticker/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/widgets/match-ticker/assets/javascripts/utils.js');
"use strict";


let FlagMap;
let getFormattedDate;
let getFormattedTime;
let EventState;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  getFormattedTime = trinidad.components.require('lb-utils', 'helper-formatdate').api.getFormattedTime;
  getFormattedDate = trinidad.components.require('lb-utils', 'helper-formatdate').api.getFormattedDate;
  EventState = trinidad.components.require('oddset', 'kambi-offering').constants.EventState;
  FlagMap = trinidad.components.require('oddset', 'common').flagMapping.FlagMap;
} else {
  getFormattedTime = svs.components.lbUtils.helpers.formatDate.getFormattedTime;
  getFormattedDate = svs.components.lbUtils.helpers.formatDate.getFormattedDate;
  EventState = svs.components.oddset.kambiOffering.common.constants.EventState;
  FlagMap = svs.components.oddset.common.flagMapping.FlagMap;
}
const generateEventConfig = event => {
  var _event$matchClock;
  const hasFlags = Boolean(FlagMap[event.awayName.toLowerCase()] && FlagMap[event.homeName.toLowerCase()]);
  const hasMatchClock = (event === null || event === void 0 || (_event$matchClock = event.matchClock) === null || _event$matchClock === void 0 ? void 0 : _event$matchClock.second) >= 0;
  return {
    awayName: event.awayName,
    homeName: event.homeName,
    awayFlag: FlagMap[event.awayName.toLowerCase()],
    homeFlag: FlagMap[event.homeName.toLowerCase()],
    hasFlags,
    score: event.score,
    eventId: event.id,
    isLive: event.state === EventState.STARTED || hasMatchClock,
    date: getFormattedDate(event.start, true, true, false, true),
    startTime: getFormattedTime(event.start),
    isSwedenPlaying: event.englishName.toLowerCase().includes('sweden')
  };
};
const addTrackingListener = (el, event) => {
  el.addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      action: 'sportsbook ticker',
      category: 'Navigation',
      opt_label: "".concat(event.name)
    });
  });
  return el;
};
const toExport = {
  generateEventConfig,
  addTrackingListener
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.widget.match_ticker.utils', toExport);
}

 })(window);